import { useEffect, useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { toysApi } from "@/lib/api";
import ToyCard from "@/components/ToyCard";

const Catalog = () => {
  const { t } = useLanguage();
  const [toys, setToys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    toysApi.list()
      .then((data) => setToys(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 md:py-24" data-testid="catalog-page">
      <div className="max-w-2xl">
        <p className="font-script text-camel text-2xl">{t.catalog.subtitle}</p>
        <h1 className="font-serif-display text-5xl md:text-6xl text-ink mt-2">{t.catalog.title}</h1>
      </div>

      {loading ? (
        <p className="mt-16 font-body text-muted-foreground">{t.common.loading}</p>
      ) : toys.length === 0 ? (
        <p className="mt-16 font-body text-muted-foreground">{t.catalog.empty}</p>
      ) : (
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {toys.map((toy, i) => (
            <ToyCard key={toy.id} toy={toy} index={i} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Catalog;
